// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__vylNB","items":"Footer_items__RxQ8a","rights":"Footer_rights__FBtWV"};